import { TableColumn } from "./dataInterface";

export const saleCompanyTableColumn: TableColumn = {
  title: "パートナー一覧",
  detail: true,
  detailTitle: "パートナー詳細",
  detailColumn: "詳細",
  detailKey: ["id", "sale_company_name"],
  addTitle: "パートナー登録",
  editAuth: ["マスターアカウント", "スタッフアカウント"],
  tableFunction: [
    {
      name: "体制図",
      width: "60px",
      auth: ["マスターアカウント", "スタッフアカウント", "パートナー"],
    },
  ],
  postCSVTitle: "",
  dataColumn: [
    {
      key: "sale_company_name",
      name: "パートナー企業名",
      tableDetailAuth: ["マスターアカウント", "スタッフアカウント"],
      table: true,
      tableMinWidth: "160px",
      sort: false,
      tableValue: "text",
      serch: true,
      serchType: "company",
      detail: true,
      edit: false,
      editType: null,
      editId: "",
      add: true,
      addType: "text",
      addMessage: "",
    },
    {
      key: "sale_company_name",
      name: "企業名",
      tableDetailAuth: ["パートナー"],
      table: true,
      tableMinWidth: "160px",
      sort: false,
      tableValue: "text",
      serch: false,
      serchType: null,
      detail: true,
      edit: false,
      editType: null,
      editId: "",
      add: false,
      addType: null,
      addMessage: "",
    },
    {
      key: "toss_up_sale_account_name_auth",
      name: "トスアップ他社担当者の表示",
      tableDetailAuth: ["マスターアカウント", "スタッフアカウント"],
      table: false,
      tableMinWidth: "120px",
      sort: false,
      tableValue: "text",
      serch: false,
      serchType: null,
      detail: true,
      edit: true,
      editType: "list",
      editId: "id",
      add: true,
      addType: "list",
      addMessage: "",
    },
    {
      key: "document_title",
      name: "システムタイトル",
      tableDetailAuth: ["マスターアカウント", "スタッフアカウント"],
      table: false,
      tableMinWidth: "120px",
      sort: false,
      tableValue: "text",
      serch: false,
      serchType: null,
      detail: true,
      edit: false,
      editType: null,
      editId: "",
      add: true,
      addType: "text",
      addMessage: "",
    },
    {
      key: "mail_address",
      name: "メールアドレス",
      tableDetailAuth: ["マスターアカウント", "スタッフアカウント"],
      table: false,
      tableMinWidth: "",
      sort: false,
      tableValue: "text",
      serch: false,
      serchType: null,
      detail: false,
      edit: false,
      editType: null,
      editId: "",
      add: true,
      addType: "text",
      addMessage: "半角数字（例:sample@sample.com）",
    },
    {
      key: "password",
      name: "初期パスワード",
      tableDetailAuth: [
        "マスターアカウント",
        "スタッフアカウント",
        "パートナー",
      ],
      table: false,
      tableMinWidth: "120px",
      sort: false,
      tableValue: "text",
      serch: false,
      serchType: null,
      detail: true,
      edit: false,
      editType: null,
      editId: "",
      add: true,
      addType: "text",
      addMessage: "8文字以上・大文字・小文字・数字・記号を含む",
    },
    {
      key: "publish_payment_xlsx",
      name: "今月の明細",
      tableDetailAuth: ["マスターアカウント", "パートナー"],
      table: true,
      tableMinWidth: "80px",
      sort: false,
      tableValue: "text",
      serch: true,
      serchType: null,
      detail: true,
      edit: false,
      editType: null,
      editId: "",
      add: false,
      addType: null,
      addMessage: "",
    },
    {
      key: "group_name",
      name: "グループ名",
      tableDetailAuth: ["マスターアカウント", "スタッフアカウント"],
      table: false,
      tableMinWidth: "",
      sort: false,
      tableValue: "text",
      serch: true,
      serchType: "group",
      detail: false,
      edit: false,
      editType: null,
      editId: "",
      add: false,
      addType: null,
      addMessage: "",
    },
    {
      key: "toss_up_product_name",
      name: "トスアップ商材",
      tableDetailAuth: ["マスターアカウント", "スタッフアカウント"],
      table: false,
      tableMinWidth: "",
      sort: false,
      tableValue: "text",
      serch: true,
      serchType: "product",
      detail: false,
      edit: false,
      editType: null,
      editId: "",
      add: false,
      addType: null,
      addMessage: "",
    },
    {
      key: "entry_product_name",
      name: "エントリー商材",
      tableDetailAuth: ["マスターアカウント", "スタッフアカウント"],
      table: false,
      tableMinWidth: "",
      sort: false,
      tableValue: "text",
      serch: true,
      serchType: "product",
      detail: false,
      edit: false,
      editType: null,
      editId: "",
      add: false,
      addType: null,
      addMessage: "",
    },
    {
      key: "collaborate_company_name",
      name: "協業パートナー",
      tableDetailAuth: ["マスターアカウント", "スタッフアカウント"],
      table: false,
      tableMinWidth: "",
      sort: false,
      tableValue: "text",
      serch: true,
      serchType: "company",
      detail: false,
      edit: false,
      editType: null,
      editId: "",
      add: false,
      addType: null,
      addMessage: "",
    },
    {
      key: "payment_s3_path",
      name: "明細ダウンロード",
      tableDetailAuth: ["マスターアカウント", "パートナー"],
      table: true,
      tableMinWidth: "120px",
      sort: false,
      tableValue: "downloadPaymentExcel",
      serch: false,
      serchType: null,
      detail: true,
      edit: false,
      editType: null,
      editId: "",
      add: false,
      addType: null,
      addMessage: "",
    },
    {
      key: "account_name",
      name: "氏名",
      tableDetailAuth: ["マスターアカウント", "スタッフアカウント"],
      table: false,
      tableMinWidth: "",
      sort: false,
      tableValue: "text",
      serch: false,
      serchType: null,
      detail: false,
      edit: false,
      editType: null,
      editId: "",
      add: true,
      addType: "text",
      addMessage: "",
    },
    {
      key: "phone_number",
      name: "TEL",
      tableDetailAuth: ["マスターアカウント", "スタッフアカウント"],
      table: false,
      tableMinWidth: "",
      sort: false,
      tableValue: "text",
      serch: false,
      serchType: null,
      detail: false,
      edit: false,
      editType: null,
      editId: "",
      add: true,
      addType: "text",
      addMessage: "半角数字（例:12-3456-7890）",
    },
  ],
  subTable: [
    {
      subTableAuth: ["マスターアカウント"],
      mainTableDetail: false,
      mainTableDetailColumn: "",
      subTableColumnName: "発行済明細一覧",
      subTableColumnLength: "xlsx_payment_length",
      detailKey: ["id"],
      subTableColumnNameWidth: "105px",
      subTableDetail: false,
      subTableDetailTitle: "発行済明細詳細",
      subTableAdd: false,
      subTableAddTitle: "発行済明細追加",
      subTableAddTitleWidth: "115px",
      subTableEdit: false,
      subTableEditTitle: "発行済明細編集",
      subTableEditDirect: false,
      subTableEditDirectKey: "",
      subTableEditAuth: [],
      tableFunction: [],
      subDataColumn: [
        {
          key: "payment_year_month",
          name: "明細年月",
          table: true,
          tableValue: "text",
          detail: false,
          edit: false,
          editType: null,
          editId: "id",
          add: false,
          addType: null,
          addMessage: "",
        },
        {
          key: "sum_high_rank_company_payment_value",
          name: "上位店入金額合計",
          table: true,
          tableValue: "text",
          detail: false,
          edit: false,
          editType: null,
          editId: "id",
          add: false,
          addType: null,
          addMessage: "",
        },
        {
          key: "sum_partner_transfer",
          name: "パートナー振込金額合計",
          table: true,
          tableValue: "text",
          detail: false,
          edit: false,
          editType: null,
          editId: "id",
          add: false,
          addType: null,
          addMessage: "",
        },
        {
          key: "sum_sale_amount",
          name: "利益金額合計",
          table: true,
          tableValue: "text",
          detail: false,
          edit: false,
          editType: null,
          editId: "id",
          add: false,
          addType: null,
          addMessage: "",
        },
        {
          key: "rate_profit",
          name: "利益率",
          table: true,
          tableValue: "text",
          detail: false,
          edit: false,
          editType: null,
          editId: "id",
          add: false,
          addType: null,
          addMessage: "",
        },
        {
          key: "payment_download",
          name: "ダウンロード",
          table: true,
          tableValue: "downloadPaymentExcel",
          detail: false,
          edit: false,
          editType: null,
          editId: "id",
          add: false,
          addType: null,
          addMessage: "",
        },
      ],
      subTable: [],
    },
    {
      subTableAuth: ["パートナー"],
      mainTableDetail: false,
      mainTableDetailColumn: "",
      subTableColumnName: "明細一覧",
      subTableColumnLength: "xlsx_payment_length",
      detailKey: ["id"],
      subTableColumnNameWidth: "105px",
      subTableDetail: false,
      subTableDetailTitle: "発行済明細詳細",
      subTableAdd: false,
      subTableAddTitle: "発行済明細追加",
      subTableAddTitleWidth: "115px",
      subTableEdit: false,
      subTableEditTitle: "発行済明細編集",
      subTableEditDirect: false,
      subTableEditDirectKey: "",
      subTableEditAuth: [],
      tableFunction: [],
      subDataColumn: [
        {
          key: "payment_year_month",
          name: "明細年月",
          table: true,
          tableValue: "text",
          detail: false,
          edit: false,
          editType: null,
          editId: "id",
          add: false,
          addType: null,
          addMessage: "",
        },
        {
          key: "sum_partner_transfer",
          name: "支払金額合計",
          table: true,
          tableValue: "text",
          detail: false,
          edit: false,
          editType: null,
          editId: "id",
          add: false,
          addType: null,
          addMessage: "",
        },
        {
          key: "payment_download",
          name: "ダウンロード",
          table: true,
          tableValue: "downloadPaymentExcel",
          detail: false,
          edit: false,
          editType: null,
          editId: "id",
          add: false,
          addType: null,
          addMessage: "",
        },
      ],
      subTable: [],
    },
    {
      subTableAuth: ["マスターアカウント", "スタッフアカウント", "パートナー"],
      mainTableDetail: false,
      mainTableDetailColumn: "",
      subTableColumnName: "グループ一覧",
      subTableColumnLength: "group_length",
      detailKey: ["id", "sale_company_id"],
      subTableColumnNameWidth: "95px",
      subTableDetail: false,
      subTableDetailTitle: "パートナー明細独自単価詳細",
      subTableAdd: true,
      subTableAddTitle: "グループ追加",
      subTableAddTitleWidth: "95px",
      subTableEdit: true,
      subTableEditTitle: "グループ編集",
      subTableEditDirect: true,
      subTableEditDirectKey: "sale_company_group_name",
      subTableEditAuth: [
        "マスターアカウント",
        "スタッフアカウント",
        "パートナー",
      ],
      tableFunction: [],
      subDataColumn: [
        {
          key: "sale_company_id",
          name: "サービス名",
          table: false,
          tableValue: "text",
          detail: false,
          edit: false,
          editType: null,
          editId: "sale_company_id",
          add: true,
          addType: "tableId",
          addMessage: "",
        },
        {
          key: "sale_company_group_name",
          name: "グループ名",
          table: true,
          tableValue: "text",
          detail: true,
          edit: true,
          editType: "text",
          editId: "id",
          add: true,
          addType: "text",
          addMessage: "",
        },
      ],
      subTable: [
        {
          subTableAuth: [
            "マスターアカウント",
            "スタッフアカウント",
            "パートナー",
          ],
          mainTableDetail: false,
          mainTableDetailColumn: "",
          subTableColumnName: "クロージングカテゴリー一覧",
          subTableColumnLength: "closing_category_length",
          detailKey: ["id", "sale_company_id"],
          subTableColumnNameWidth: "140px",
          subTableDetail: false,
          subTableDetailTitle: "クロージングカテゴリー詳細",
          subTableAdd: true,
          subTableAddTitle: "クロージングカテゴリー追加",
          subTableAddTitleWidth: "140px",
          subTableEdit: false,
          subTableEditTitle: "クロージングカテゴリー編集",
          subTableEditDirect: false,
          subTableEditDirectKey: "",
          subTableEditAuth: [],
          tableFunction: [],
          subDataColumn: [
            {
              key: "category_name",
              name: "カテゴリー",
              table: true,
              tableValue: "text",
              detail: false,
              edit: false,
              editType: null,
              editId: "id",
              add: true,
              addType: "closing_category",
              addMessage:
                "指定がない場合、カテゴリーによるトスアップ一覧の制限がされなくなります。",
            },
          ],
          subTable: [],
        },
      ],
    },
    {
      subTableAuth: ["マスターアカウント", "スタッフアカウント"],
      mainTableDetail: false,
      mainTableDetailColumn: "",
      subTableColumnName: "明細独自単価一覧",
      subTableColumnLength: "unique_payment_length",
      detailKey: ["id"],
      subTableColumnNameWidth: "115px",
      subTableDetail: true,
      subTableDetailTitle: "パートナー明細独自単価詳細",
      subTableAdd: true,
      subTableAddTitle: "明細独自単価追加",
      subTableAddTitleWidth: "115px",
      subTableEdit: true,
      subTableEditTitle: "パートナー明細独自単価編集",
      subTableEditDirect: false,
      subTableEditDirectKey: "",
      subTableEditAuth: ["マスターアカウント", "スタッフアカウント"],
      tableFunction: [],
      subDataColumn: [
        {
          key: "sale_company_id",
          name: "サービス名",
          table: false,
          tableValue: "text",
          detail: false,
          edit: false,
          editType: null,
          editId: "sale_company_id",
          add: true,
          addType: "tableId",
          addMessage: "",
        },
        {
          key: "sale_company_unique_payment_name",
          name: "パートナー明細独自単価 - 名前",
          table: true,
          tableValue: "text",
          detail: true,
          edit: true,
          editType: "text",
          editId: "id",
          add: true,
          addType: "text",
          addMessage: "",
        },
        {
          key: "sale_company_unique_payment_value",
          name: "パートナー明細独自単価 - 値",
          table: true,
          tableValue: "text",
          detail: true,
          edit: true,
          editType: "text",
          editId: "id",
          add: true,
          addType: "text",
          addMessage: "",
        },
      ],
      subTable: [],
    },
    {
      subTableAuth: ["マスターアカウント", "スタッフアカウント"],
      mainTableDetail: false,
      mainTableDetailColumn: "",
      subTableColumnName: "トスアップ商材一覧",
      subTableColumnLength: "toss_up_product_length",
      detailKey: ["id"],
      subTableColumnNameWidth: "140px",
      subTableDetail: false,
      subTableDetailTitle: "トスアップ商材詳細",
      subTableAdd: true,
      subTableAddTitle: "トスアップ商材追加",
      subTableAddTitleWidth: "140px",
      subTableEdit: false,
      subTableEditTitle: "トスアップ商材編集",
      subTableEditDirect: false,
      subTableEditDirectKey: "",
      subTableEditAuth: [],
      tableFunction: [],
      subDataColumn: [
        {
          key: "high_rank_company_name",
          name: "上位店名",
          table: true,
          tableValue: "text",
          detail: false,
          edit: false,
          editType: null,
          editId: "id",
          add: false,
          addType: "text",
          addMessage: "",
        },
        {
          key: "category_name",
          name: "カテゴリー",
          table: true,
          tableValue: "text",
          detail: false,
          edit: false,
          editType: null,
          editId: "id",
          add: false,
          addType: "text",
          addMessage: "",
        },
        {
          key: "product_name",
          name: "商材名",
          table: true,
          tableValue: "text",
          detail: false,
          edit: false,
          editType: null,
          editId: "id",
          add: true,
          addType: "toss_up_product",
          addMessage: "",
        },
      ],
      subTable: [
        {
          subTableAuth: ["マスターアカウント", "スタッフアカウント"],
          mainTableDetail: false,
          mainTableDetailColumn: "",
          subTableColumnName: "指定 - クロージングパートナー一覧",
          subTableColumnLength: "closer_company_length",
          detailKey: ["id"],
          subTableColumnNameWidth: "100px",
          subTableDetail: false,
          subTableDetailTitle: "クロージングパートナー詳細",
          subTableAdd: true,
          subTableAddTitle: "指定 - クロージングパートナー追加",
          subTableAddTitleWidth: "100px",
          subTableEdit: false,
          subTableEditTitle: "クロージングパートナー編集",
          subTableEditDirect: false,
          subTableEditDirectKey: "",
          subTableEditAuth: [],
          tableFunction: [],
          subDataColumn: [
            {
              key: "closer_company_name",
              name: "指定 - クロージングパートナー",
              table: true,
              tableValue: "text",
              detail: false,
              edit: false,
              editType: null,
              editId: "id",
              add: true,
              addType: "closer_company",
              addMessage:
                "指定がない場合、トスアップしたパートナーのみクロージング可能となります。",
            },
          ],
          subTable: [],
        },
      ],
    },
    {
      subTableAuth: ["マスターアカウント", "スタッフアカウント"],
      mainTableDetail: false,
      mainTableDetailColumn: "",
      subTableColumnName: "エントリー商材一覧",
      subTableColumnLength: "entry_product_length",
      detailKey: ["id"],
      subTableColumnNameWidth: "140px",
      subTableDetail: false,
      subTableDetailTitle: "エントリー商材詳細",
      subTableAdd: true,
      subTableAddTitle: "エントリー商材追加",
      subTableAddTitleWidth: "140px",
      subTableEdit: false,
      subTableEditTitle: "エントリー商材編集",
      subTableEditDirect: false,
      subTableEditDirectKey: "",
      subTableEditAuth: [],
      tableFunction: [],
      subDataColumn: [
        {
          key: "high_rank_company_name",
          name: "上位店名",
          table: true,
          tableValue: "text",
          detail: false,
          edit: false,
          editType: null,
          editId: "id",
          add: false,
          addType: "text",
          addMessage: "",
        },
        {
          key: "category_name",
          name: "カテゴリー",
          table: true,
          tableValue: "text",
          detail: false,
          edit: false,
          editType: null,
          editId: "id",
          add: false,
          addType: "text",
          addMessage: "",
        },
        {
          key: "product_name",
          name: "商材名",
          table: true,
          tableValue: "text",
          detail: false,
          edit: false,
          editType: null,
          editId: "id",
          add: true,
          addType: "entry_product",
          addMessage:
            "※同一商材名をエントリー商材に複数設定することはできません。",
        },
      ],
      subTable: [],
    },
    {
      subTableAuth: ["マスターアカウント", "スタッフアカウント"],
      mainTableDetail: false,
      mainTableDetailColumn: "",
      subTableColumnName: "協業パートナー一覧",
      subTableColumnLength: "collaborate_company_length",
      detailKey: ["id"],
      subTableColumnNameWidth: "140px",
      subTableDetail: false,
      subTableDetailTitle: "協業パートナー詳細",
      subTableAdd: true,
      subTableAddTitle: "協業パートナー追加",
      subTableAddTitleWidth: "140px",
      subTableEdit: false,
      subTableEditTitle: "協業パートナー編集",
      subTableEditDirect: false,
      subTableEditDirectKey: "",
      subTableEditAuth: [],
      tableFunction: [],
      subDataColumn: [
        {
          key: "collaborate_company_name",
          name: "協業パートナー名",
          table: true,
          tableValue: "text",
          detail: false,
          edit: false,
          editType: null,
          editId: "id",
          add: true,
          addType: "collaborate_company",
          addMessage:
            "※エントリー・トスアップ時の担当者を協業パートナーのアカウントに変更できるようになります。",
        },
      ],
      subTable: [],
    },
  ],
};
